/**
 * SupplierPriority Component
 * Panel za upravljanje prioritetom dobavljača
 */

import { useState } from 'react';
import {
  Box,
  Typography,
  Alert,
  Collapse,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  IconButton,
  Divider,
} from '@mui/material';
import {
  ExpandMore as ExpandIcon,
  ExpandLess as CollapseIcon,
  DragIndicator as DragIcon,
  ArrowUpward as UpIcon,
  ArrowDownward as DownIcon,
} from '@mui/icons-material';
import { SupplierPriority as SupplierPriorityType } from '../../../lib/supabase';

interface SupplierPriorityProps {
  priorities: SupplierPriorityType[];
  onMovePriority: (index: number, direction: 'up' | 'down') => Promise<void>;
}

export function SupplierPriority({
  priorities,
  onMovePriority,
}: SupplierPriorityProps) {
  const [expanded, setExpanded] = useState(false);

  return (
    <>
      <Divider sx={{ my: 2 }} />

      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 1 }}>
        <Typography variant="subtitle2" color="text.secondary">
          Prioritet dobavljača
        </Typography>
        <IconButton size="small" onClick={() => setExpanded(!expanded)}>
          {expanded ? <CollapseIcon /> : <ExpandIcon />}
        </IconButton>
      </Box>

      <Collapse in={expanded}>
        <Alert severity="info" sx={{ mb: 1, py: 0, fontSize: '0.7rem' }}>
          Najviši = uzima podatke (naziv, cijena...). Količine se zbrajaju od svih.
        </Alert>

        <List dense disablePadding>
          {priorities.map((sp, index) => (
            <ListItem
              key={sp.supplier_name}
              dense
              sx={{
                bgcolor: index === 0 ? 'success.dark' : 'transparent',
                borderRadius: 1,
                mb: 0.5,
              }}
              secondaryAction={
                <Box sx={{ display: 'flex', gap: 0 }}>
                  <IconButton
                    size="small"
                    disabled={index === 0}
                    onClick={() => onMovePriority(index, 'up')}
                  >
                    <UpIcon fontSize="small" />
                  </IconButton>
                  <IconButton
                    size="small"
                    disabled={index === priorities.length - 1}
                    onClick={() => onMovePriority(index, 'down')}
                  >
                    <DownIcon fontSize="small" />
                  </IconButton>
                </Box>
              }
            >
              <ListItemIcon sx={{ minWidth: 28 }}>
                <DragIcon fontSize="small" color="action" />
              </ListItemIcon>
              <ListItemText
                primary={
                  <Typography variant="body2" fontWeight={index === 0 ? 600 : 400}>
                    {index + 1}. {sp.supplier_name}
                  </Typography>
                }
              />
            </ListItem>
          ))}
        </List>

        {priorities.length === 0 && (
          <Typography variant="caption" color="text.secondary">
            Nema dobavljača. Importuj feed da dodaš.
          </Typography>
        )}
      </Collapse>
    </>
  );
}
